import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import MultipleFileInput from '@/components/Ui/MultipleFileInput'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Validator from '@/utils/Validator'
import ImageResize from "@/utils/ImageResize";

export default {
  name: 'File',
  components: {
    Loading,
    MultipleFileInput
  },
  metaInfo () {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  data () {
    return {
      loading: true,
      processing: false,
      registerHash: Constants.RegisterHash,

      // テーブルオプション
      tableColumns: [
        'fileId',
        'fileName',
        'services',
        'createdAt',
        'modifyButton',
        'deleteButton'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          fileId: 'ファイルID',
          fileName: 'ファイル名',
          services: '対象サービス',
          createdAt: '登録日時',
          modifyButton: '',
          deleteButton: ''
        },
        columnsClasses: {
          fileId: 'wp-5',
          fileName: '',
          services: '',
          createdAt: '',
          modifyButton: 'wp-5 has-button',
          deleteButton: 'wp-5 has-button'
        },
        sortable: [
          'fileId',
          'fileName',
          'services',
          'createdAt'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts(this.categoryName),
        // perPage: Constants.TableOptions.perPage.view,
        perPage: Constants.TablePerPageInitial,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,

      // 入力フォーム
      inpFile: null,
      // inpService: [],

      // 編集・削除
      modifyTargetId: null,
      deleteTargetId: null
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.$set(this.tableOptions, 'texts', Constants.TableOptions.getTexts(this.categoryName))

    this.init()
    this.initRegister()
  },
  computed: {
    ...mapState({
      categoryName: state => state.file.categoryName,

      // model
      fileModel: state => state.file.fileModel,
      serviceModel: state => state.file.serviceModel,
      tenantModel: state => state.file.tenantModel,

      // 検索
      filters: state => state.file.filters,

      // form
      values: state => state.file.values,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      permittedView: 'permission/permittedView',
      isSmartPhone: 'core/isSmartPhone',
      isRegister: 'file/isRegister',
      isModify: 'file/isModify'
    }),

    // title
    formTitle () {
      const id = Utility.getObjectArrayValue(this.fileModel, 'fileUuid', this.modifyTargetId, 'fileId')
      return this.isRegister ?
        this.categoryName + '登録' :
        this.categoryName + '変更（Id : ' + id + '）'
    },
    formButtonLabel () {
      return this.isRegister ? '登録' : '変更'
    },

    // list
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },
    serviceList() {
      return this.serviceModel.map(item => {
        return {
          value: item.serviceUuid,
          label: item.serviceName
        }
      })
    },
    tenantList() {
      return this.tenantModel.map(item => {
        return {
          value: item.tenant.tenantUuid,
          label: item.tenant.name
        }
      })
    },

    // filter
    searchFileName: {
      get () {
        return this.filters.searchFileName
      },
      set (value) {
        this.setInputFilter({
          key: 'searchFileName',
          value: value
        })
      }
    },
    searchService: {
      get () {
        return this.filters.searchService
      },
      set (value) {
        this.setInputFilter({
          key: 'searchService',
          value: value
        })
      }
    },
    searchTenant: {
      get () {
        return this.filters.searchTenant
      },
      set (value) {
        this.setInputFilter({
          key: 'searchTenant',
          value: value
        })
      }
    },

    // input
    inpService: {
      get () {
        return this.values.inpService
      },
      set (value) {
        this.setInputValue({
          key: 'inpService',
          value: value
        })
      }
    },

    // result
    resultFile () {
      try {
        return this.fileModel.filter(item => item.fileUuid === this.modifyTargetId)[0].fileName
      /* eslint-disable no-new */
      } catch (e) {
        return ''
      }
    },
    resultService () {
      if (this.inpService && this.inpService.length) {
        let list = this.serviceModel
          .filter(item => this.inpService.indexOf(item.serviceUuid) !== -1)
          .map(item => item.serviceName)
        return list.join('、')

      } else {
        return 'すべてのサービス'
      }
    },

    // validate
    inpFileIsValid () {
      return Validator.validFile(this.inpFile)
    },
    formIsValid () {
      return this.isRegister
        ? this.inpFileIsValid
        : true
    },
    disablePostButton () {
      return !this.formIsValid
    }
  },
  watch: {
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // 登録
      if (this.confirmKey === 'register') {
        if (to) this.postData()
      }

      // 削除
      if (this.confirmKey === 'delete') {
        to ?
          this.deleteData() :
          this.deleteTargetId = null
      }
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'file/loadModel',
      loadFileList: 'file/loadFileList',
      initRegister: 'file/initRegister',
      initModify: 'file/initModify',
      showFileSelectServiceModal: 'fileSelectServiceModal/show'
    }),
    ...mapMutations({
      setInputFilter: 'file/setInputFilter',
      setInputValue: 'file/setInputValue',
    }),

    init () {
      this.loading = true

      //
      let fileParams = {}
      let serviceParams = {}

      // データ読出し
      this.loadModel({
        fileParams: fileParams,
        serviceParams: serviceParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.fileModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    // ファイル登録
    changeFile ({index, file}) {
      this.inpFile = file
    },
    // changeFile (e) {
    //   // console.log(e.target.files[0])
    //   this.inpFile = e.target.files[0]
    // },
    showServiceSelector () {
      this.showFileSelectServiceModal()
    },
    confirmData() {
      if (!this.formIsValid) return

      const id = Utility.getObjectArrayValue(this.fileModel, 'fileUuid', this.modifyTargetId, 'fileId')
      this.showConfirm({
        key: 'register',
        title: '',
        body: this.isRegister ?
          'この内容で' + this.categoryName + 'を登録しますか？' :
          '「Id : ' + id + '」の' + this.categoryName + '情報を変更しますか？'
      })
    },
    async postData () {
      this.processing = true

      //
      let parameters = {
        request: {
          serviceKbn: this.values.inpService.length ? 1 : 0
        }
      }
      if (parameters.request.serviceKbn === 1) {
        parameters.request.serviceUuids = this.values.inpService
      }
      if (this.isRegister) {
        parameters.request.attachment = await ImageResize.getCompressedImage(this.inpFile)
      }
      if (this.isModify) {
        parameters.fileUuid = this.modifyTargetId
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['file'],
        [this.isRegister ?
          'v1FilePost' :
          'v1FilePatch'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: this.isRegister ?
                '新しい' + this.categoryName + 'の登録' :
                '登録' + this.categoryName + '情報の変更',
              body: this.isRegister ?
                this.categoryName + 'を登録しました。' :
                this.categoryName + 'を変更しました。'
            })

            // this.modifyTargetId = null

            // inputを初期化
            this.registerItem()

            // 一覧データを再読出し
            this.search()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }

        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },
    deleteData () {
      this.processing = true

      let parameters = {
        fileUuid: this.deleteTargetId
      }
      console.log('delete data', parameters)

      // 登録
      ApiManager.request(
        ['file'],
        ['v1FileDelete'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: this.categoryName + 'の削除',
              body: this.categoryName + 'を削除しました。'
            })

            this.deleteTargetId = null

            // 変更対象になっているものが削除された場合の対応
            this.modifyTargetId = null
            this.inpFile = null
            this.inpService = []

            // 一覧データを再読出し
            this.search()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }

        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },

    // 登録済みファイル一覧
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      if (key === 'services') {
        if (props.row.serviceKbn === 0) {
          return 'すべてのサービス'
        } else {
          let list = value.map(item => item.serviceName)
          return list.length ? list.join('、') : ''
        }
      }
      if (key === 'createdAt')
        return Utility.dateFormat(value, 'YYYY/MM/DD HH:mm')
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    // 検索
    resetSearch () {
      this.searchFileName = null
      this.searchService = ''
      this.searchTenant = ''

      this.search()
    },
    search () {
      this.loading = true

      //
      let fileParams = {}
      if (this.searchFileName)
        fileParams.fileName = this.searchFileName
      if (this.searchService !== '')
        fileParams.serviceUuid = this.searchService
      if (this.searchTenant !== '')
        fileParams.tenantUuid = this.searchTenant
      console.log(fileParams);

      // データ読出し
      this.loadFileList({
        fileParams: fileParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.fileModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    // 絞り込み
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    registerItem () {
      this.modifyTargetId = null
      this.inpFile = null
      this.initRegister()
    },
    modifyItem (props) {
      this.modifyTargetId = props.row.fileUuid
      this.initModify({
        data: props.row
      })
    },
    deleteItem (props) {
      this.deleteTargetId = props.row.fileUuid
      const id = Utility.getObjectArrayValue(this.fileModel, 'fileUuid', this.deleteTargetId, 'fileId')
      this.showConfirm({
        key: 'delete',
        title: '',
        body: '「Id : ' + id + '」の' + this.categoryName + 'を削除しますか？',
        acceptLabel: '削除'
      })
    }
  }
}